
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/storage-unit-cost",
      function () {
        return require("private-next-pages/storage-unit-cost/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/storage-unit-cost"])
      });
    }
  